import { useEffect, useState } from 'react';
import { useAuth } from '../context/AuthContext';
import { supabase } from '../lib/supabase';

/**
 * Returns whether the currently authenticated caregiver has at least one senior.
 * Used by the configure wizard to redirect existing caregivers to the dashboard
 * (B2C: one caregiver = one senior).
 */
export function useHasSenior() {
  const { user } = useAuth();
  const [hasSenior, setHasSenior] = useState(false);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    if (!user) {
      setHasSenior(false);
      setLoading(false);
      return;
    }

    let cancelled = false;
    setLoading(true);

    supabase
      .from('seniors')
      .select('id')
      .eq('caregiver_id', user.id)
      .limit(1)
      .then(({ data, error }) => {
        if (cancelled) return;
        if (error) {
          console.warn('[useHasSenior] Fetch error:', error);
          setHasSenior(false);
        } else {
          setHasSenior((data?.length ?? 0) > 0);
        }
        setLoading(false);
      });

    return () => {
      cancelled = true;
    };
  }, [user]);

  return { hasSenior, loading };
}
